import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SizeDetectorService } from 'src/app/shared/utils/size-detector.service';
import { SCREEN_SIZE } from 'src/app/shared/models/screen-size.enum';
import { Observable, Subscription } from 'rxjs';
import {
  IUser,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { SiteManagementService } from 'src/app/site-management/site-management.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { AccountSettingsService } from '../account-settings/account-setting.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  mobileClasses = [SCREEN_SIZE.XS, SCREEN_SIZE.SM, SCREEN_SIZE.MD];
  showMobileHeader = false;
  subscription: Subscription | undefined;
  sharedData: any;
  siteId!: string;
  siteItem: any[] = [];
  profileDetails!: IUserProfile;

  @Input() user!: Observable<IUser | undefined>;

  constructor(
    private sizeDetectorService: SizeDetectorService,
    private siteManagementService: SiteManagementService,
    public sharedDataService: SharedDataService,
    private accountSettingService: AccountSettingsService
  ) {}

  ngOnInit(): void {
    this.sizeDetectorService.currentData.subscribe((size: any) => {
      this.showMobileHeader = this.mobileClasses.includes(size);
    });

    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
        if (this.siteItem.length > 0) {
          this.siteItem.forEach((selectedItem: any) => {
            if (selectedItem.siteId === sharedData.selectedSite.siteId)
              selectedItem.siteName = sharedData.selectedSite.siteName;
          });
        }
        //adding this condition for performance update
        // From !this.siteId || == to ==> (!this.siteId && this.sharedData.selectedSite.siteId) ||
        if (
          (!this.siteId && this.sharedData.selectedSite.siteId) ||
          (this.sharedData.selectedSite.siteId &&
            this.siteId != this.sharedData.selectedSite.siteId)
        ) {
          this.siteId = this.sharedData.selectedSite.siteId;
          this.getUserInfo();
        }
      }
    );

    this.siteManagementService.getAllSites().subscribe({
      next: (res: any) => {
        this.siteItem = res;
        if (this.sharedData?.selectedSite?.siteId) {
          const selectedItem: any = this.siteItem.find(
            (currentSite: any) =>
              currentSite.siteId === this.sharedData?.selectedSite?.siteId
          );

          if (selectedItem && selectedItem !== -1) {
            this.sharedDataService.setSelectedSite({
              siteId: selectedItem.siteId,
              siteName: selectedItem.siteName,
              siteTimeZone: selectedItem.siteTimeZone,
              commonAccessControl: selectedItem.commonAccessControl
            });
          }
        }
      },

      error: (err: Error) => {
        this.sharedDataService.setSelectedSite({
          siteId: '',
          siteName: '',
          siteTimeZone: '',
          commonAccessControl: true
        });
      },
    });
  }

  private getUserInfo() {
    this.accountSettingService
      .getMyPersonalInfo(this.sharedData?.selectedSite?.siteId)
      .subscribe({
        next: (userProfile: IUserProfile) => {
          this.profileDetails = userProfile;
        },
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.sizeDetectorService.updateSize(event.target.innerWidth);
  }
}
